import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// English(UK)(en)(English)
import translationEN from './resources/locales/en/translation.json';
// Español(es)(spanish)
import translationES from './resources/locales/es/translation.json';
// 中文(zh)(Chinese (Simplified))
import translationZH from './resources/locales/zh/translation.json';
// Français(French)
import translationFR from './resources/locales/fr/translation.json';
// Nederlands(Dutch)
import translationNL from './resources/locales/nl/translation.json';
// Português(Portugese)
import translationPT from './resources/locales/pt/translation.json';
// Pусский(Russian)
import translationRU from './resources/locales/ru/translation.json';
// afrikaans
import translationZA from './resources/locales/za/translation.json';
//malay
import translationMY from './resources/locales/my/translation.json';
//Polish
import translationPL from './resources/locales/pl/translation.json';
//turkish
import translationTR from './resources/locales/tr/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  zh: {
    translation: translationZH,
  },
  fr: {
    translation: translationFR,
  },
  nl: {
    translation: translationNL,
  },
  pt: {
    translation: translationPT,
  },
  ru: {
    translation: translationRU,
  },
  za: {
    translation: translationZA,
  },
  my: {
    translation: translationMY,
  },
  pl: {
    translation: translationPL,
  },
  tr: {
    translation: translationTR,
  },
};
i18n
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
